import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./locales/es.json";
import en from "./locales/en.json";

/**
 * `<html lang>` sigue al idioma REAL de la interfaz. El navegador decide por ese
 * atributo si ofrece traducir la pagina: con el `lang="en"` de la plantilla de Vite,
 * Chrome/Edge en espanol traducian el chat "del ingles" y estropeaban las respuestas
 * del agente ("dime" salia como "diez centavos", se perdian trozos al streamear).
 * Se usa `resolvedLanguage` ("es"/"en") y no `language`, que es lo detectado
 * ("es-ES", "pt-PT") aunque la interfaz caiga al espanol por `fallbackLng`.
 * Se registra antes de `init` para que tambien cubra el idioma inicial.
 */
i18n.on("languageChanged", () => {
  document.documentElement.lang = i18n.resolvedLanguage ?? "es";
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
